import script from "./divider-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./divider-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__